import React, { useContext } from 'react';

import { QuestionStarRatingDefaultProps, QuestionStarRatingPropTypes } from 'src/components/JobDatasheet/propTypes';
import JobDatasheetLanguageContext from 'src/components/JobDatasheet/context/JobDatasheetLanguageContext';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionStarRating = ({
  isRectifiedQuestion,
  onChange,
  question: {
    starRatingSettings: { numberOfStarsAvailable, rows },
    translations,
  },
  value,
}) => {
  const { selectedLanguage } = useContext(JobDatasheetLanguageContext);
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const stars = [...Array(numberOfStarsAvailable)];

  const getTranlatedRow = (index) => {
    if (!selectedLanguage) {
      return rows[index];
    }

    const textTranslation = (translations || []).find(c => c.languageId === selectedLanguage)?.options?.[index];

    return textTranslation?.value ?
      textTranslation.value :
      textTranslation || rows[index];
  }

  const getReturnObject = (val, index) => {
    const returnObject = {
      ...value,
      type: 'starRating'
    };

    let returnValue;

    if (index !== undefined) {
      const row = [...Array(rows.length)];
      const rowValue = row.map((_val, rowIndex) => Array.isArray((value || {})[selectedValueKey]) ? (value || {})[selectedValueKey][rowIndex] : null );
      rowValue[index] = val;
      returnValue = rowValue;
    } else {
      returnValue = val;
    }

    returnObject[selectedValueKey] = returnValue;

    return returnObject;
  };
  return (
    <>
      {!rows || !rows?.length > 0 ? (
        stars.map((_val, starIndex) => (
          <s.StarWrapper
            key={starIndex}  
            selected={(value || {})[selectedValueKey] >= (starIndex + 1)}
            >
            <s.StarIcon
              name="question-type-star-rating"
              onClick={e => {
                e.stopPropagation();

                onChange(getReturnObject(starIndex + 1));
              }}
            />
          </s.StarWrapper>
        ))
      ) : (
        rows.map((rowVal, rowIndex)=> (
          <s.StarRow key={rowIndex}>
            <div>
            {getTranlatedRow(rowIndex)}
            </div>
            {stars.map((_val, starIndex) => (
                  <s.StarWrapper
                    key={starIndex}  
                    selected={((value || {})[selectedValueKey]?.at(rowIndex)) >= (starIndex + 1)}
                  >
                    <s.StarIcon
                      name="question-type-star-rating"
                      onClick={e => {
                        e.stopPropagation();

                        onChange(getReturnObject(starIndex + 1, rowIndex));
                      }}
                    />
                  </s.StarWrapper>              
              ))}
          </s.StarRow>
        ))
      )}
    </>
  );
};

QuestionStarRating.propTypes = QuestionStarRatingPropTypes;
QuestionStarRating.defaultProps = QuestionStarRatingDefaultProps;
